import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
function createAtlasDatePickerActionBar({ applyButtonLabel = "Apply", cancelButtonLabel = "Cancel", }) {
    function AtlasDatePickerActionBar({ onAccept, onCancel }) {
        const { tokens: { component: { calendar: { container: { padding }, }, datePicker: { footer }, }, }, } = useTheme();
        return (_jsx(Box, Object.assign({ sx: {
                paddingInline: padding.value,
                paddingBottom: padding.value,
            } }, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "flex-end", sx: applyTokens(footer) }, { children: [_jsx(Button, Object.assign({ onClick: onCancel }, { children: cancelButtonLabel })), _jsx(Button, Object.assign({ onClick: onAccept, variant: "contained" }, { children: applyButtonLabel }))] })) })));
    }
    return AtlasDatePickerActionBar;
}
function createAtlasDatePickerToolbar({ selectDateLabel = "Select date", selectYearLabel = "Select year", }) {
    function AtlasDatePickerToolbar({ openView, setOpenView, parsedValue, }) {
        const { tokens: { component: { button: { secondary: { active }, }, calendar: { container: { padding }, }, datePicker, }, }, } = useTheme();
        const isYearView = openView === "year";
        const year = parsedValue instanceof Date ? parsedValue.getFullYear() : "??";
        const handleYearViewClick = () => {
            if (!isYearView) {
                setOpenView("year");
            }
            else {
                setOpenView("day");
            }
        };
        return (_jsx(Box, Object.assign({ sx: {
                paddingInline: padding.value,
                paddingTop: padding.value,
            }, className: `AtlasDatePickerToolbar AtlasDatePickerToolbar-${openView}` }, { children: _jsxs(Stack, Object.assign({ justifyContent: "space-between", alignItems: "center", direction: "row", sx: applyTokens(datePicker.header) }, { children: [_jsx(Typography, Object.assign({ variant: "h5", sx: applyTokens(datePicker.header.title) }, { children: isYearView ? selectYearLabel : selectDateLabel })), _jsx(Button, Object.assign({ variant: "outlined", size: "small", sx: isYearView ? applyTokens(active) : {}, onClick: handleYearViewClick }, { children: year }))] })) })));
    }
    return AtlasDatePickerToolbar;
}
export const DatePickerPresets = () => {
    return {
        withAtlasToolbar(toolbarLabels) {
            return {
                ToolbarComponent: createAtlasDatePickerToolbar(toolbarLabels),
                showToolbar: true,
            };
        },
        withAtlasActionBar(actionBarLabels) {
            return {
                components: {
                    ActionBar: createAtlasDatePickerActionBar(actionBarLabels),
                },
            };
        },
    };
};
//# sourceMappingURL=datePicker.js.map